module["exports"] = [
  "#{street_name} #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/address/street_address.js
// module id = 1526
// module chunks = 0